import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ResourceInfo } from '@vendasta/platform-integrations';

@Component({
  selector: 'platform-integration-resources',
  imports: [MatIconModule, CommonModule],
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent {
  @Input() resources!: ResourceInfo[];
}
